// import Observer from '../../common/scripts/observer';
// const observer = new Observer();

class Share {
    constructor() {
        this.isOpen = false;
        this.openClass = 'is-open';
        this.hiddenClass = 'is-hidden';
        this.shareButtonSelector = '.j-share__button';
        this.shareContainerSelector = '.j-share__container';
        this.shareContentSelector = '.j-share__content';
        this.shareEmailButtonSelector = '.j-share__email';
        this.shareFormSelector = '.j-share__form';
        this.stepBackSelector = '.j-share__form-back';
        this.delay = 300;
    }

    init(options) {
        this._setOptions(options);
        this._getElements();
        this._bindEvents();
    }

    _setOptions(options) {
        this.target = options.target;
    }

    _getElements() {
        // Общий контейнер
        this.shareContainer = this.target.querySelector(this.shareContainerSelector);
        // Блок с вариантами "поделиться"
        this.shareContent = this.shareContainer.querySelector(this.shareContentSelector);
        // Вариант отправки по email
        this.email = this.shareContent.querySelector(this.shareEmailButtonSelector);

        if (this.email) {
            // Находим контейнер формы
            this.formContainer = this.shareContainer.querySelector(this.shareFormSelector);
            this.stepBack = this.shareContainer.querySelector(this.stepBackSelector);
        }
    }

    _bindEvents() {
        if (this.target) {
            this.target.addEventListener('click', this._open.bind(this));
        }

        if (this.email) {
            this.email.addEventListener('click', this._emailForm.bind(this));
            this.stepBack.addEventListener('click', this._stepBack.bind(this));
        }
    }

    _open(event) {
        if (!event.target) {
            return;
        }

        if (event.target.closest(this.shareButtonSelector)) {
            this.target.classList.toggle(this.openClass);
        }

        if (!this.target.classList.contains(this.openClass)) {
            this._setInitialContent();
        }
    }

    _emailForm(event) {
        if (!event.target) {
            return;
        }

        this.shareContent.classList.add(this.hiddenClass);
        this.shareContent.classList.remove(this.openClass);

        this.formContainer.classList.add(this.openClass);
        this.formContainer.classList.remove(this.hiddenClass);
    }

    _setInitialContent() {
        setTimeout(() => {
            this.formContainer.classList.remove(this.openClass);
            this.shareContent.classList.remove(this.hiddenClass);
        }, this.delay);
    }

    _stepBack() {
        this.shareContent.classList.remove(this.hiddenClass);
        this.shareContent.classList.add(this.openClass);

        this.formContainer.classList.remove(this.openClass);
        this.formContainer.classList.add(this.hiddenClass);
    }
}

export default Share;
